import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import {
  SectionName, buildPlxData,
} from '../common/styles';
import {
  BaseContainer, BaseDesc, BaseTitle,
} from './styles';

const vPadding = 140;
const Container = styled(BaseContainer)`
  ${props => (props.theme.isMobile ? `
    margin-top: 40px;
  ` : `
    margin-top: ${vPadding + 8}px;
    margin-bottom: ${vPadding + 8}px;
  `)};

  & > .right {
    ${props => (props.theme.isMobile ? `
      order: 0;
    ` : `
      order: 3;
      max-width: 560px;
      width: 44vw;
      max-height: 465px;
      height: 32vw;
      padding-left: 4vw;
    `)};
  }
`;

const ContentSupportImg = styled(Img)`
  position: relative;
  border-radius: 10px;
  ${props => (props.theme.isMobile ? `
    width: calc(100vw - 40px);
    height: calc(88.9vw - 36px);
  ` : `
    width: 36vw;
    max-width: 516px;
    max-height: 465px;
    height: 32vw;
  `)};
`;

export default function ContentSupport() {
  const { ongoingContentSupportImg, isMobile } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#content-support-container', vPadding);
  return (
    <Container id="content-support-container">
      <Plx className="left-section" parallaxData={plxData.image} disabled={isMobile}>
        <ContentSupportImg src={ongoingContentSupportImg} />
      </Plx>
      <Plx className="right" parallaxData={plxData.text} disabled={isMobile}>
        <SectionName>Solutions</SectionName>
        <BaseTitle>Ongoing Content support</BaseTitle>
        <BaseDesc>
          Our team of content experts provide advice and analysis
          to help improve your performance and is committed to
          your success.
        </BaseDesc>
      </Plx>
    </Container>
  );
}
